import React from "react";
import { cn } from "../lib/utils";

/** Labels for client engagement type (field `service_tier`); legacy tier values map to new names. */
const ENGAGEMENT_LABELS = {
  brand_design: "Brand design",
  web_design: "Web design",
  product_design: "Product design",
  operational_ecosystem: "Operational ecosystem",
  essentials: "Brand design",
  growth: "Web design",
  partnership: "Operational ecosystem",
  infrastructure: "Operational ecosystem",
};

const SPECIAL_LABELS = {
  taistu: "TAĪSTU",
  TAISTU: "TAĪSTU",
};

/** Use with `flex-nowrap` + truncated title so pills fit one row below `sm`. */
export const STATUS_PILL_ROW_COMPACT_CLASS =
  "shrink-0 max-sm:!text-[9px] max-sm:!px-2 max-sm:!py-[2px] max-sm:!tracking-[0.12em] max-sm:!gap-1";

/**
 * Outlined status pill. Maps semantic status to a tone.
 * Tones: default, accent, ok, warn, error, meta
 */
export const StatusPill = ({ status, tone, label, dot = false, className, "data-testid": testId }) => {
  const map = {
    // file / approval / generic
    draft: "meta",
    for_review: "warn",
    approved: "ok",
    final: "accent",
    paid: "accent",
    pending: "warn",
    revision_requested: "error",
    // task
    todo: "meta",
    in_progress: "accent",
    in_review: "warn",
    complete: "ok",
    // milestone
    not_started: "meta",
    // calendar
    milestone: "accent",
    call: "ok",
    deadline: "error",
    event: "meta",
    // engagement type (stored as service_tier; legacy tiers aliased visually)
    brand_design: "meta",
    web_design: "accent",
    product_design: "warn",
    operational_ecosystem: "ok",
    essentials: "meta",
    growth: "accent",
    partnership: "ok",
    archived: "meta",
    shared: "ok",
    ready: "ok",
  };
  const t = tone || map[status] || "default";
  const cls = t === "default" ? "" : `t-pill-${t}`;
  const rawText =
    label ||
    (status && ENGAGEMENT_LABELS[status]) ||
    (status || "").replace(/_/g, " ");
  const text = SPECIAL_LABELS[rawText] || SPECIAL_LABELS[status] || rawText;
  return (
    <span className={cn("t-pill", cls, className)} data-testid={testId}>
      {dot && <span className="t-dot" />}
      {text}
    </span>
  );
};
